import { render } from "./Mint.vue?vue&type=template&id=60e05c8c&scoped=true"
import script from "./Mint.vue?vue&type=script&lang=js"
export * from "./Mint.vue?vue&type=script&lang=js"

import "./Mint.vue?vue&type=style&index=0&id=60e05c8c&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e05c8c"]])

export default __exports__